var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPart1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 1000 1000",
    width: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      flex: "1 1 0%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.305 442.491c3.722-57.278-37.222-91.522-92.267-91.522-112.366 0-165.922 108.644-165.922 208.355 0 68.401 34.2 119.067 107.155 119.067 61.745 0 106.368-40.2 126.467-96.033h46.9c-28.289 87.8-86.311 135.444-179.322 135.444-95.245 0-148.056-64.022-148.056-158.478 0-119.767 76.633-247.767 208.311-247.767 83.334 0 146.567 41.645 143.59 130.934h-46.856zm363.145 18.602c.744-18.61-5.212-33.5-15.634-43.878-9.677-9.722-23.077-14.144-40.944-14.889-74.4-2.977-97.478 75.145-97.478 133.956 0 55.745 21.633 88.5 64.022 88.5 40.156 0 63.978-26.011 73.656-65.466h122.745c-23.034 110.133-99.668 158.477-201.612 158.477-107.155 0-185.278-54.3-185.278-168.199 0-136.845 90.034-240.279 229.9-240.279 97.478 0 172.667 48.389 173.367 151.778H784.45z",
    fill: "rgb(124, 0, 47)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPart1);
export default __webpack_public_path__ + "static/media/logo-part-1.da3bf4437f87fc23f169a382821fd471.svg";
export { ForwardRef as ReactComponent };